import React, { useEffect, useState } from "react";
import Button from "../../../../Elements/Button/Button.js";
import parse from "html-react-parser";
import "../Profile.scss";
import "./MyAccount.scss";
import MyAccountCard from "./MyAccountCard.js";
import UserSubscriptionDetailsCard from "./MyAccountsCards/UserSubscriptionDetailsCard.js";
import UserMailsAndStorageDetails from "./MyAccountsCards/UserMailsAndStorageDetails.js";
import SubUsersManagementDetails from "./MyAccountsCards/SubUsersManagementDetails.js";
import SubUserTable from "../SubUsers/SubUserTable.js";
import MobileSubUserDetails from "../SubUsers/MobileSubUserDetails.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../../../contexts/userContext/userContext.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useProfile } from "contexts/profileContext/profileContext.js";
import AnimationContainer from "components/Reusable/AnimationContainer/AnimationContainer.js";
import SideElementContainer from "./MyAccountSideElements/SideElementContainer.js";
import { DownloadSubUsersList } from "../DownloadSubUsersList/index.tsx";
import { useToasts } from "react-toast-notifications";

const MAX_SUB_USERS_VISIBLE = 5;
const MyAccount = () => {
  const { getTextByKey } = useContent();
  const {
    isBusiness,
    isPremium,
    isSubscribed,
    getUserData,
    getIsPendingLogin,
    getUserBillingDetails,
  } = useUser();
  const { getSelectedSubUser, getSubUsersCounts, getSubUserData } =
    useProfile();
  const userData = getUserData();
  const billingDetails = getUserBillingDetails();
  const [userIsAutoRenew, setUserIsAutoRenew] = useState(
    billingDetails?.auto_renew
  );
  const [show, setShow] = useState(false);
  const { addToast } = useToasts();

  // Update userIsAutoRenew value when userData login from this (Account) page
  useEffect(() => {
    if (userData) {
      setUserIsAutoRenew(billingDetails?.auto_renew);
    }
  }, [billingDetails?.auto_renew]);

  // Show success message when user renews subscription
  // and remove the query string from the URL
  useEffect(() => {
    if (window.location.search.includes("renew-subscription-success")) {
      addToast(getTextByKey("renew-subscription-success"), {
        appearance: "success",
        autoDismiss: true,
      });

      // Remove the query string from the URL
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname + window.location.hash
      );
    }
  }, []);

  return (
    <>
      {userData.IsConfirm ? (
        <div className="main-section-myaccount">
          <div className="hello-message-section">
            <div className="text">
              <h1 className="title">
                {getTextByKey("profileuser-title") +
                  " " +
                  userData.UserFirstName +
                  "!"}
              </h1>
              <div className="sub-user-title">
                {getTextByKey("profileuser-welcome-sub-title")}
              </div>
              {!userData.IsSubUser ? (
                <div className="manage-payment-details">
                  {getTextByKey("manage-payment-details")}
                  <LinkToNewTab page="user/profile/payments">
                    {getTextByKey("here")}
                  </LinkToNewTab>
                </div>
              ) : null}
            </div>
          </div>

          {getIsPendingLogin() ? (
            <LoadingImageElement />
          ) : (
            <div className="cards-container">
              {/* user subscripbition details */}
              <MyAccountCard>
                <UserSubscriptionDetailsCard
                  userData={userData}
                  setShow={setShow}
                  userIsAutoRenew={userIsAutoRenew}
                  setUserIsAutoRenew={setUserIsAutoRenew}
                />
              </MyAccountCard>
              <MyAccountCard>
                <UserMailsAndStorageDetails userData={userData} />
              </MyAccountCard>

              {isSubscribed() && !userData.IsSubUser && (
                <MyAccountCard>
                  <SubUsersManagementDetails userData={userData} />
                </MyAccountCard>
              )}
            </div>
          )}

          {(!userData.IsSubUser || userData.IsAdminSubUser) &&
            userData.UserTotalSubUsersLicenses > 0 && (
              <>
                <div className="sub-users-container">
                  {isBusiness() || isPremium() ? (
                    <div>
                      <div className="account-users-table-header">
                        {!!getSubUserData().numberOfUsers && (
                          <>
                            <h3 className="account-users-table-title main">
                              {getTextByKey("account-users")}
                            </h3>
                            <h3>
                              {getTextByKey("sub-users-active")} :{" "}
                              {getSubUsersCounts()?.active || 0}
                            </h3>
                            <div className="manage-all-button">
                              {getSubUserData().numberOfUsers >
                                MAX_SUB_USERS_VISIBLE && (
                                <LinkToNewTab page="user/profile/account-users">
                                  <Button
                                    buttonClass="account-users-table-manage-all"
                                    white
                                  >
                                    {getTextByKey("sub-users-manage-all")} (
                                    {getSubUserData().numberOfUsers})
                                  </Button>
                                </LinkToNewTab>
                              )}
                            </div>
                            <DownloadSubUsersList className="account-users-subusers-download" />
                          </>
                        )}
                      </div>
                      <div className="sub-users-container-table">
                        {/* if desktop display table if mobile display small cards */}
                        <SubUserTable
                          pageSize={MAX_SUB_USERS_VISIBLE}
                          withoutPagination
                        />
                        {getSubUserData().numberOfUsers >
                          MAX_SUB_USERS_VISIBLE && (
                          <div className="sub-users-container-table-footer">
                            <LinkToNewTab page="user/profile/account-users">
                              <Button className>
                                {getTextByKey("show-more")}
                              </Button>
                            </LinkToNewTab>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="upgrade-to-business">
                      <div className="upgrade-to-business-text">
                        {parse(
                          getTextByKey("profileuser-upgrade-to-business-text")
                        )}
                      </div>

                      <div className="upgrade-to-business-button">
                        <LinkToNewTab page="plans" isNewTab={true}>
                          <Button medium>
                            {getTextByKey(
                              "profileuser-upgrade-to-business-button"
                            )}
                          </Button>
                        </LinkToNewTab>
                      </div>
                    </div>
                  )}
                </div>
                {Object.keys(getSelectedSubUser()).length > 0 && (
                  <MobileSubUserDetails
                    mobileSelectedUser={getSelectedSubUser()}
                  />
                )}
              </>
            )}
          <AnimationContainer
            animationOn={show}
            animationClassName="side-bar-animation"
          >
            <SideElementContainer
              setShowElement={setShow}
              elementName={"cancel-subscription"}
              setUserIsAutoRenew={setUserIsAutoRenew}
            />
          </AnimationContainer>
        </div>
      ) : !userData.IsConfirm ? (
        <div className="not-confirm-alert">
          {getTextByKey("profileuser-must-confirm")}
        </div>
      ) : (
        <div className="load-container">
          <LoadingImageElement />
        </div>
      )}
    </>
  );
};

export default MyAccount;
